import React from 'react';

// 이용약관. Shown in the sign-up layer and at /Terms (store listing link).
const Policy01 = () => (
  <div id="policy">
    <h3>두벅 영워드 이용약관</h3>

    <div className='area'>
      <strong className='title'>제 1 조 (목적)</strong>
      <p>이 약관은 코드모도(codemodo, 이하 "운영자")가 제공하는 두벅 영워드(이하 "서비스")를 이용하는 데 필요한 조건과 절차, 이용자와 운영자의 권리·의무를 정합니다.</p>
    </div>

    <div className='area'>
      <strong className='title'>제 2 조 (서비스 내용)</strong>
      <p>서비스는 영어 단어·예문·회화·문법 학습, 복습 일정 관리, 학습 기록(출석, 연속 학습, 시험 결과) 기능을 무료로 제공합니다. 운영자는 더 나은 학습을 위해 서비스 내용을 바꿀 수 있으며, 중요한 변경은 앱 안에서 미리 알립니다.</p>
    </div>

    <div className='area'>
      <strong className='title'>제 3 조 (회원가입과 계정)</strong>
      <p>만 14세 이상이면 이메일 또는 카카오·Google·Apple 계정으로 가입할 수 있습니다. 이용자는 자신의 계정 정보를 안전하게 관리해야 하며, 다른 사람의 정보로 가입해서는 안 됩니다.</p>
    </div>

    <div className='area'>
      <strong className='title'>제 4 조 (이용자의 의무)</strong>
      <p>이용자는 서비스를 비정상적인 방법으로 이용하거나, 서버에 과도한 부하를 주거나, 다른 이용자의 이용을 방해해서는 안 됩니다. 이를 어기면 운영자는 이용을 제한할 수 있습니다.</p>
    </div>

    <div className='area'>
      <strong className='title'>제 5 조 (콘텐츠의 권리)</strong>
      <p>서비스의 예문·회화·문법 콘텐츠와 디자인의 권리는 운영자에게 있습니다. 단어 목록은 NGSL·TSL(CC BY-SA 4.0)을 바탕으로 하며, 출처는 마이페이지의 '만든 사람들'에서 확인할 수 있습니다. 이용자는 개인 학습 목적으로만 콘텐츠를 이용할 수 있습니다.</p>
    </div>

    <div className='area'>
      <strong className='title'>제 6 조 (탈퇴)</strong>
      <p>이용자는 언제든지 마이페이지의 '회원 탈퇴'로 탈퇴할 수 있으며, 탈퇴하면 학습 기록을 포함한 개인정보는 즉시 삭제됩니다.</p>
    </div>

    <div className='area'>
      <strong className='title'>제 7 조 (책임의 한계)</strong>
      <p>서비스는 무료로 제공되며, 운영자는 천재지변·통신 장애 등 운영자가 통제할 수 없는 사유로 생긴 손해에 대해 책임지지 않습니다. 운영자는 서비스를 안정적으로 제공하기 위해 노력합니다.</p>
    </div>

    <div className='area'>
      <strong className='title'>제 8 조 (약관의 변경)</strong>
      <p>약관을 바꿀 때는 시행 7일 전(이용자에게 불리한 변경은 30일 전)부터 앱 안에서 알립니다. 바뀐 약관에 동의하지 않으면 탈퇴할 수 있습니다.</p>
    </div>

    <div className='area'>
      <strong className='title'>부칙</strong>
      <p>이 약관은 2026년 10월 21일부터 시행합니다.</p>
    </div>
  </div>
);

export default Policy01;
